import RESTSerializer from '@ember-data/serializer/rest';

export default class DeepDiveGreenOptionRoomSerializer extends RESTSerializer {}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'deep-dive/green-option/room': DeepDiveGreenOptionRoomSerializer;
  }
}
